// extracted by mini-css-extract-plugin
export default {"root":"Comparables__root--gGCKz","comparable":"Comparables__comparable--HLeRo"};